import React from "react";

function MrbInfiniteScrollGridEmptyState() {
    return <div>There is no data.</div>;
}

export default MrbInfiniteScrollGridEmptyState;
